export default __webpack_public_path__ + "static/media/72b.57a48be2.svg";